<template>
  <section class="relative bg-white md:bg-transparent md:grid md:grid-cols-12 lg:max-w-screen-lg lg:mx-auto xl:max-w-screen-xl xl:px-12 lg:gap-x-16">
    <slot />
    <div class="relative px-4 pt-4 pb-10 sm:px-12 sm:pt-8 sm:pb-12 md:bg-white lg:pt-12 xl:px-20 xl:py-20 2xl:px-24 2xl:py-24 md:col-span-10 md:col-start-2 lg:rounded-2xl">
      <div class="lg:w-4/5">
        <span
          v-for="type in schoolTypes"
          :id="type.title"
          :key="type.title"
          class="hidden lg:inline-block lg:text-xl xl:text-2xl font-bold leading-tight mb-3 text-app-secondary-7-violet--purple-heart"
        >
          {{ type.title }}
        </span>
        <span v-if="seasonTitle" class="hidden mx-2 lg:inline-block lg:text-xl xl:text-2xl leading-tight mb-3 text-app-secondary-7-violet--purple-heart"> | </span>
        <span class="hidden lg:inline-block lg:text-xl xl:text-2xl leading-tight mb-3 text-app-secondary-7-violet--purple-heart">
          {{ seasonTitle }}
        </span>

        <h1 class="leading-[1.08] hidden lg:block lg:w-4/5 font-bold lg:text-4xl xl:text-5xl mb-4 text-app-secondary-7-violet--purple-heart">
          {{ title }}
        </h1>

        <div class="prose prose--app prose--app--violet font-semibold text-sm mb-6" v-html="introduction" />

        <section v-if="body">
          <div class="prose prose--app prose--app--violet" v-html="body" />
        </section>

        <section v-if="musicians.length" class="prose prose--app prose--app--violet mt-6">
          <h4 class="text-xl font-semibold mb-2">{{ t_('performers') }}</h4>
          <div class="sm:grid grid-cols-2 sm:gap-x-6 md:gap-y-1 lg:grid-cols-1 xl:grid-cols-2">
            <div v-for="musician in musicians" :key="musician.id">
              <span class="font-semibold">{{ musician.title }}</span>
              <span v-if="musician.instrumentDescription">{{ ' ' }}{{ musician.instrumentDescription }}</span>
            </div>
          </div>
        </section>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
defineProps({
  // Defaults to an empty array, not undefined: the only caller passes `get(page, 'musicians')`, which is
  // undefined whenever the CMS has no musicians, and the template reads `musicians.length` unguarded.
  musicians: { type: Array as PropType<any[]>, required: false, default: () => [] },
  schoolTypes: { type: Array as PropType<any[]>, required: false, default: undefined },
  seasonTitle: { type: String, required: false, default: undefined },
  date: { type: Date, required: false, default: undefined },
  title: { type: String, required: false, default: undefined },
  introduction: { type: String, required: false, default: undefined },
  body: { type: String, required: false, default: undefined },
  theme: { type: String, required: false, default: undefined },
})

const { t_ } = setupTranslationPrefixer('EducationProductionDetailPageBody')
</script>
